import React, { useEffect, useState } from "react"
import { CalendarClock, Plus, Trophy, UsersRound } from "lucide-react"
import { api } from "../api"
import { useAuth } from "../auth"
import { Link } from "../router"
import { Card, EmptyState, ErrorNotice, EventRow, PageHeader, TeamMark } from "../ui"

export function DashboardPage() {
  const { session } = useAuth()
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => { api("/dashboard").then(setData).catch(setError) }, [])

  return (
    <div className="page">
      <PageHeader eyebrow="Clubhouse overview" title={`Good ${dayPart()}, ${session.coach.first_name}.`} copy="Here’s what needs your attention across every team." actions={<Link className="button button--primary" to="/teams"><Plus size={17} /> New team</Link>} />
      <ErrorNotice error={error} />
      <div className="stat-grid">
        <Card><span className="stat-icon stat-icon--blue"><UsersRound /></span><span><small>Active teams</small><strong>{data?.counts.teams ?? "—"}</strong></span></Card>
        <Card><span className="stat-icon stat-icon--orange"><Trophy /></span><span><small>Rostered players</small><strong>{data?.counts.players ?? "—"}</strong></span></Card>
        <Card><span className="stat-icon stat-icon--green"><CalendarClock /></span><span><small>Upcoming games</small><strong>{data?.counts.upcoming_games ?? "—"}</strong></span></Card>
      </div>
      <div className="dashboard-grid">
        <Card className="panel">
          <div className="panel__header"><div><p className="eyebrow">Next up</p><h2>Upcoming schedule</h2></div></div>
          {data && [...data.upcoming_games, ...data.upcoming_practices].sort((a, b) => new Date(a.game_date || a.practice_date) - new Date(b.game_date || b.practice_date)).slice(0, 6).map(event => <EventRow key={`${event.game_date ? "g" : "p"}-${event.id}`} event={event} />)}
          {data && !data.upcoming_games.length && !data.upcoming_practices.length ? <EmptyState icon={CalendarClock} title="The calendar is open" copy="Add a game or practice from a team page." /> : null}
        </Card>
        <Card className="panel">
          <div className="panel__header"><div><p className="eyebrow">Your organization</p><h2>Teams</h2></div><Link to="/teams">View all</Link></div>
          <div className="team-list">
            {data?.teams.map(team => <Link key={team.id} className="team-row" to={`/teams/${team.id}`}><TeamMark team={team} /><span><strong>{team.name}</strong><small>{team.season}</small></span><span>→</span></Link>)}
          </div>
          {data?.teams.length === 0 ? <EmptyState icon={UsersRound} title="Create your first team" copy="Add a season, build a roster, and schedule your first event." action={<Link className="button button--secondary" to="/teams">Get started</Link>} /> : null}
        </Card>
      </div>
    </div>
  )
}

function dayPart() {
  const hour = new Date().getHours()
  if (hour < 12) return "morning"
  if (hour < 18) return "afternoon"
  return "evening"
}
